import Head from "next/head"

import Another from "../../components/another-component"
import Button from "../../components/button"
import data from "../../components/data"
import { PythonPrerequisite } from "../../components/info"
import {
  courseDataToSchema,
  schemaElementFromSchema,
} from "../../components/utils"

const Course = () => {
  const courseId = "p-ws"
  const schema = courseDataToSchema(data, courseId)
  const courseInstances = schema.courseInstances
  const schemaElement = schemaElementFromSchema(schema)
  return (
    <div>
      <Head>
        <title>Web scraping su Python | Pirmas kodas</title>
        <meta
          name="description"
          content="Kursas Web scraping su Python. Čia išmoksite efektyviai, tiksliai ir saugiai rinkti duomenus iš interneto, juos valyti, apdoroti saugoti."
        />
      </Head>
      {schemaElement}

      <article className="prose dark:prose-invert">
        <div>
          <h1>Web scraping su Python</h1>
          <div>
            <h3>Tikslinė auditorija</h3>
            <p>
              Norite greitai ir masiškai surinkti duomenis iš interneto
              puslapių? Šis kursas būtent Jums.
            </p>
          </div>
          <PythonPrerequisite />
          <div>
            <h3>Kurso turinys</h3>
            <div>
              <h3>Temos</h3>
              <ul>
                <li>HTML</li>
                <li>CSS</li>
                <li>Javascript</li>
                <li>XPATH ir kiti selektoriai</li>
                <li>VPN</li>
                <li>Proxy</li>
                <li>Scrapy</li>
                <li>lxml</li>
                <li>Beautiful Soup</li>
                <li>Selenium</li>
                <li>Pyppetteer</li>
                <li>Playwrite</li>
                <li>Baigiamasis projektas</li>
              </ul>
            </div>
          </div>
        </div>

        {courseInstances ? (
          <>
            <h2>Artimiausios grupės</h2>
            {courseInstances.map((instance) => {
              return Another(instance, data.links.generalRegistrationForm)
            })}
          </>
        ) : (
          <Button href={data.links.generalRegistrationForm} />
        )}
      </article>
    </div>
  )
}

export default Course
